import Backbone from 'backbone'
import _ from 'lodash'
import $ from 'jquery'
import i18n from 'scoreboard/components/i18n'
import filter from './filtered-list-filter.hbs'
import InfiniteScroller from 'scoreboard/components/infinite-scroller'
import LoadingDots from 'scoreboard/components/loading-dots'
import scrollContainer from 'scoreboard/components/scroll-container'
import DisplayHeader from 'scoreboard/components/display-header'
import appDisplay from 'scoreboard/components/app-display'
import EmptyState from 'scoreboard/components/empty-state'
import TooltipAndDetails from 'scoreboard/components/tooltip-and-details'
import nonAbbreviatedValuesTooltip from 'scoreboard/components/non-abbreviated-values-tooltip.hbs'
import SortableStreamedTableView from 'scoreboard/components/sortable-streamed-table-view'

/**
 * Common base class for my tasks and my metrics screens
 */
var FilteredList = Backbone.View.extend({

	className: 'filtered-list',

	events: {
		'click .show-all': '_removeFilter',
		'click .filter': 'filter'
	},

	initialize: function(options = {}) {
		this.options = _.defaults(options, {sortOptions: {}})
		this.sortableTable = new SortableStreamedTableView(_.assign({
			el: this.el
		}, this.options.sortOptions))
		this.listenTo(this.sortableTable, 'sorted', (stream) => {
			this.sortableTable.renderHeaders()
			this.setupStream(stream)
		})
	},

	render: function() {
		var self = this
		this.$el.empty().append(new DisplayHeader({
			heading: self.heading(),
			mobileGearHidden: true
		}).render().el, this._template())
		if (this._displayHomeNav) {
			this.renderHomeNav(this.$el)
		}
		// Show loading dots until we have some data available
		this.$('.display-pane-body').addClass('is-not-displayed')
		this.$('.show-all').addClass('is-not-displayed')
		this.loadingDots = new LoadingDots({ el: this.$('.loading-dots-container') })
		this.loadingDots.render()

		this.displayPaneHeader = this.$('.display-pane-header')
		this.displayPaneBody = this.$('.display-pane-body')
		this.showAll = this.$('.show-all')
		// start everything hidden until we have some data available
		this.displayPaneHeader.addClass('is-not-displayed')
		this.displayPaneBody.addClass('is-not-displayed')
		this.showAll.addClass('is-not-displayed')

		this.sortableTable.renderHeaders()

		return this
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.sortableTable, this.loadingDots], 'remove')
	},

	setCountsByColor: function(counts) {
		var html = ''
		_.each(counts, function(count, color) {
			// #9371 don't show counts of 0
			if (count == 0) {
				return
			}

			html += filter({
				color: color,
				colorClasses: 'icon ' + (color || ''),
				iconName: this._filterIcon,
				countMessage: i18n.countMessage(this._countKeyPrefix, count)
			})
		}.bind(this))
		this.$('.filters').append(html)
	},

	setOrgs: function(orgs) {
		this._orgs = orgs
		this._orgsById = _.keyBy(orgs, 'id')
	},

	setupStream: function(stream) {
		this.$('tbody').empty()
		this._objects = []
		this._stream = stream
		stream.once('data', this._firstData.bind(this))
		stream.on('data', this._onData.bind(this))
		stream.on('end', this._onData.bind(this))
		this.loadingDots.observeStream(stream)
		this.sortableTable.observeStream(stream)
	},

	_firstData: function(){
		this.displayPaneHeader.removeClass('is-not-displayed')
		this.displayPaneBody.removeClass('is-not-displayed')
		// This can't be setup in stream() because it gets invoked before render()
		// (the streamer is started in home-router.js)
		this._setupInfiniteScroller()
	},

	_setupInfiniteScroller: function () {
		this._scroller = new InfiniteScroller({ el: scrollContainer(this.el) })
		this._scroller.on('scroll', this._stream.next.bind(this._stream))
		this._stream.on('data', this._scroller.dataReady.bind(this._scroller))
	},

	_onData: function(objects) {
		var noData = _.isEmpty(this._objects) && _.isEmpty(objects)
		if( _.isUndefined(objects) || noData ){
			if( noData ){
				this.emptyState = new EmptyState({
					heading: this.heading(),
					body: this.emptyTemplate()
				})
				appDisplay.display(this.emptyState)
				if (this._displayHomeNav) {
					this.renderHomeNav(this.emptyState.$el)
				}

			}
			//.on('end') an return undefined, just ignore
			return
		}
		this.$('.display-pane-body').removeClass('is-not-displayed')
		this._objects = this._objects.concat(objects)

		this._renderObjects(objects)
	},

	_clear: function() {
		this.lastOrgId = null
		this._done = false
		// clear out the table
		this.$('tbody').empty()
		this.$('.panel-content').scrollTop(0)
	},

	_renderObjects: function(objects) {
		var html = ''
		_.each(objects, function(object) {

			let state = this.sortableTable.state() || {}
			if (_.isNil(state.sortField) && object.organizationId != this.lastOrgId) {
				let orgRowCtx = this._orgRowMeta()
				html += orgRowCtx.template({
					label: this._orgsById[object.organizationId].label,
					colspan: orgRowCtx.colspan
				})
				this.lastOrgId = object.organizationId
			}

			html += this._renderObject(object)
		}.bind(this))
		this.$('tbody').append(html)
		this._updateDisplay()
	},

	_removeFilter: function() {
		delete this.filterColor
		this._clear()
		this.showAll.addClass('is-not-displayed')

		this.$('.filter').removeClass('is-inactive')
		this.sortableTable.filter().applySort()
	},

	filter: function(e) {
		var color = $(e.target).closest('[data-color]').data('color')
		if( color === this.filterColor ){
			this._removeFilter()
		} else {
			this.filterColor = color
			this._clear()
			this.showAll.removeClass('is-not-displayed')
			this.$('.filter').toggleClass('is-inactive', true)
			this.$('.filter[data-color=' + color + ']').removeClass('is-inactive')
			this.sortableTable.filter(this._filterByColor.bind(this)).applySort()
		}
	},

	_filterByColor (object) {
		return this._getColor(object) == this.filterColor
	},

	// #13322 allows the views that extend FilteredList to make
	// changes to the DOM that need to occur *after*
	// the objects have been rendered by _renderObjects
	// (for example hiding the scores on my metrics #13004)
	_updateDisplay: function() {
		this.nonAbbreviatedTooltip && this.nonAbbreviatedTooltip.remove()
		this.nonAbbreviatedTooltip = new TooltipAndDetails({
			el: this.el,
			selector: this.$('[data-unshortened-value]'),
			tooltipContent: (e) => {
				return nonAbbreviatedValuesTooltip({
					header: e.target.dataset.unshortenedHeader,
					value: e.target.dataset.unshortenedValue
				})
			},
			tooltipOptions: {
				extraClass: 'tooltip-and-details non-abbreviated-tooltip filtered-list-non-abbreviated-tooltip'
			}
		})
		return
	}

})

export default FilteredList

FilteredList.__filename__ = 'home/filtered-list/filtered-list.js'
